import Block from '../../../components/Block/Block';
import Button from '../../../components/Button/Button';
import style from './bannerblock.module.scss';
import banner from '../../../assets/banner.jpg';

const BannerBlock = () => {
    return (
        <Block
            width="100%"
            height='200px'
            background="#0a0a2e"
        >
            <div className={style.content}>
                <div 
                    className={style.backgroundOverlay}
                    aria-hidden="true"
                />
                <div 
                    className={style.sportWaves}
                    aria-hidden="true"
                />
                <div className={style.wrapperHeader}>
                    <h2 className={style.header}>
                        НАША КОМАНДА
                    </h2>
                </div>
            </div>
        </Block>
    );
};

export default BannerBlock;